<template>
  <div>
    <DataLoader :is_on="creating_report" />
    <div id="table" class="report-table breakdown-report">
      <div class="print-wrapper" @click="print()">
        <span>{{ $t("reports.breakdown.save_report") }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="36"
          viewBox="0 0 30 36"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5574 0C11.0601 0 9.81104 1.21625 9.68029 2.8016C9.40692 6.11624 9.33774 9.44566 9.47296 12.7686C9.30973 12.7802 9.14654 12.7923 8.98336 12.8049L6.10045 13.0283C4.25777 13.1711 3.2277 15.3548 4.22251 17.0096C6.34414 20.5386 9.07791 23.6066 12.2781 26.05L13.4331 26.9318C14.3695 27.6468 15.6308 27.6468 16.5672 26.9318L17.7222 26.05C20.9224 23.6066 23.6562 20.5386 25.7778 17.0096C26.7726 15.3548 25.7425 13.1711 23.8999 13.0283L21.017 12.8049C20.8538 12.7923 20.6906 12.7802 20.5273 12.7686C20.6626 9.44565 20.5934 6.11623 20.32 2.80158C20.1893 1.21624 18.9402 0 17.4429 0H12.5574ZM12.4482 14.1217C12.2281 10.4452 12.2692 6.75601 12.5712 3.08571H17.4291C17.7311 6.75601 17.7722 10.4452 17.5521 14.1217C17.5274 14.5339 17.6593 14.9394 17.9181 15.2474C18.177 15.5555 18.5412 15.7404 18.9294 15.7607C19.5552 15.7934 20.1807 15.834 20.8059 15.8825L22.8996 16.0447C21.0424 18.9521 18.717 21.4911 16.0284 23.5438L15.0002 24.3289L13.9719 23.5438C11.2833 21.4911 8.95788 18.9521 7.10071 16.0447L9.19443 15.8825C9.81957 15.834 10.4451 15.7934 11.0709 15.7607C11.4591 15.7404 11.8233 15.5555 12.0822 15.2474C12.341 14.9394 12.4729 14.5339 12.4482 14.1217Z"
            fill="#606076"
          />
          <path
            d="M2.90323 28.2857C2.90323 27.4336 2.25332 26.7429 1.45161 26.7429C0.649909 26.7429 0 27.4336 0 28.2857V32.4C0 34.3882 1.51646 36 3.3871 36H26.6129C28.4835 36 30 34.3882 30 32.4V28.2857C30 27.4336 29.3501 26.7429 28.5484 26.7429C27.7467 26.7429 27.0968 27.4336 27.0968 28.2857V32.4C27.0968 32.684 26.8801 32.9143 26.6129 32.9143H3.3871C3.11986 32.9143 2.90323 32.684 2.90323 32.4V28.2857Z"
            fill="#606076"
          />
        </svg>
      </div>
      <div class="top-logo">
        <svg
          width="428"
          height="188"
          viewBox="0 0 428 188"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2_41)">
            <path
              d="M12.42 155.44C18.78 155.44 21.54 158.5 21.67 162.57C21.7413 163.995 21.4083 165.412 20.7093 166.656C20.0102 167.9 18.9737 168.922 17.7192 169.602C16.4647 170.283 15.0434 170.595 13.6192 170.503C12.195 170.41 10.826 169.917 9.67 169.08V168.73C10.9767 168.814 12.2714 168.435 13.3266 167.66C14.3818 166.885 15.13 165.762 15.44 164.49C15.6227 163.758 15.7001 163.004 15.67 162.25C15.57 159.08 13.86 157.01 10.89 157.01H8.44V178.77C8.45308 179.395 8.71065 179.99 9.15745 180.428C9.60425 180.865 10.2047 181.11 10.83 181.11H11.3V181.48H0V181.11H0.470001C1.09435 181.11 1.69372 180.865 2.13893 180.427C2.58413 179.989 2.83951 179.394 2.85 178.77V158C2.81638 157.403 2.54863 156.843 2.10489 156.443C1.66115 156.042 1.07725 155.833 0.48 155.86H0V155.49L12.42 155.44Z"
              fill="#5C5C5C"
            />
            <path
              d="M52.0702 170.33C52.0702 177.51 46.7902 181.97 38.8902 181.97C30.9902 181.97 25.7402 177.51 25.7402 170.33C25.7402 163.15 31.0002 158.69 38.8902 158.69C46.7802 158.69 52.0702 163.13 52.0702 170.33ZM46.3502 170.33C46.3502 164.04 43.4302 160.15 38.8902 160.15C34.3502 160.15 31.4402 164.04 31.4402 170.33C31.4402 176.62 34.4402 180.49 38.8902 180.49C43.3402 180.49 46.3502 176.61 46.3502 170.33Z"
              fill="#5C5C5C"
            />
            <path
              d="M67.5401 159.16C71.6601 159.16 75.6601 160.62 75.6601 165.26C75.7146 166.728 75.212 168.162 74.2531 169.275C73.2942 170.388 71.95 171.097 70.4901 171.26C72.0007 171.891 73.2621 173.002 74.0801 174.42C74.9014 175.855 75.8063 177.241 76.7901 178.57C78.2401 180.57 79.0701 181.09 80.6101 181.1V181.47H77.4901C73.4901 181.47 71.5501 180.69 69.7801 177.91C68.7745 176.309 67.9399 174.606 67.2901 172.83C66.6601 171.27 65.7401 170.61 65.0601 170.55V170.24H66.0601C67.6001 170.24 69.3001 169.64 69.9201 166.52C70.0132 166.019 70.0401 165.508 70.0001 165C69.8301 161.34 67.3301 160.8 66.0001 160.75C65.0001 160.7 64.2901 160.75 63.8701 160.75V179.18C63.8701 179.71 64.0808 180.219 64.4559 180.594C64.831 180.969 65.3397 181.18 65.8701 181.18H66.2801V181.55H56.1101V181.18H56.5501C57.0703 181.18 57.5701 180.978 57.9435 180.616C58.3169 180.253 58.5345 179.76 58.5501 179.24V161.54C58.5502 161.28 58.4981 161.023 58.3969 160.784C58.2957 160.544 58.1474 160.328 57.9608 160.147C57.7743 159.966 57.5533 159.824 57.3109 159.73C57.0686 159.636 56.8099 159.592 56.5501 159.6H56.1001V159.23L67.5401 159.16Z"
              fill="#5C5C5C"
            />
            <path
              d="M107.68 170.33C107.68 177.51 102.4 181.97 94.5099 181.97C86.6199 181.97 81.3599 177.51 81.3599 170.33C81.3599 163.15 86.6399 158.69 94.5099 158.69C102.38 158.69 107.68 163.13 107.68 170.33ZM101.96 170.33C101.96 164.04 99.0399 160.15 94.5099 160.15C89.9799 160.15 87.0599 164.04 87.0599 170.33C87.0599 176.62 89.9999 180.49 94.5099 180.49C99.0199 180.49 101.96 176.61 101.96 170.33Z"
              fill="#5C5C5C"
            />
            <path
              d="M121.51 159.16C125.43 159.16 129.91 160.06 129.91 164.72C129.955 165.866 129.556 166.985 128.796 167.844C128.036 168.703 126.973 169.236 125.83 169.33C129.03 169.56 131.67 171.75 131.67 175.13C131.67 179.78 127.32 181.48 122.31 181.48H111.52V181.11H111.94C112.47 181.11 112.979 180.899 113.354 180.524C113.729 180.149 113.94 179.64 113.94 179.11V161.49C113.94 160.96 113.729 160.451 113.354 160.076C112.979 159.701 112.47 159.49 111.94 159.49H111.52V159.12L121.51 159.16ZM120.77 180C123.42 180 125.63 178.59 125.63 174.8C125.63 171.25 123.4 169.67 120.34 169.7V169.37C122.6 169.37 124.34 168.14 124.34 165.08C124.34 161.75 122.65 160.61 120.34 160.61H119.29V180H120.77Z"
              fill="#5C5C5C"
            />
            <path
              d="M135.62 181.48V181.11H136.06C136.332 181.121 136.604 181.077 136.859 180.982C137.115 180.887 137.349 180.743 137.548 180.557C137.747 180.371 137.907 180.147 138.019 179.899C138.131 179.65 138.192 179.382 138.2 179.11V161.51C138.192 161.238 138.131 160.97 138.019 160.721C137.907 160.473 137.747 160.249 137.548 160.063C137.349 159.877 137.115 159.733 136.859 159.638C136.604 159.543 136.332 159.499 136.06 159.51H135.62V159.14H146.16V159.51H145.73C145.179 159.491 144.643 159.691 144.238 160.065C143.834 160.44 143.594 160.959 143.57 161.51V179.17C143.594 179.723 143.835 180.244 144.242 180.618C144.649 180.993 145.187 181.192 145.74 181.17H146.18V181.54L135.62 181.48Z"
              fill="#5C5C5C"
            />
            <path
              d="M160.82 159.16V159.53H160.4C159.848 159.516 159.313 159.717 158.906 160.09C158.499 160.463 158.254 160.979 158.22 161.53V180.33C158.22 185.27 153.7 188.4 149 187.95V187.62C151.87 186.39 152.86 183.27 152.86 180.27V161.5C152.827 160.951 152.582 160.436 152.177 160.063C151.773 159.691 151.24 159.489 150.69 159.5H150.26V159.12L160.82 159.16Z"
              fill="#5C5C5C"
            />
            <path
              d="M185.25 179C185.484 179.591 185.885 180.102 186.403 180.471C186.921 180.84 187.535 181.052 188.17 181.08H188.45V181.45H177.52V181.08H177.81C178.058 181.094 178.306 181.04 178.527 180.924C178.747 180.809 178.932 180.636 179.062 180.424C179.192 180.212 179.263 179.968 179.266 179.719C179.269 179.47 179.205 179.225 179.08 179.01L177.63 175.61H169.75L168.27 179.06C168.158 179.274 168.106 179.515 168.117 179.756C168.128 179.997 168.203 180.231 168.334 180.435C168.465 180.638 168.648 180.803 168.863 180.912C169.078 181.022 169.319 181.073 169.56 181.06H169.85V181.43H162.42V181.06H162.72C163.327 181.032 163.914 180.836 164.416 180.493C164.917 180.151 165.313 179.675 165.56 179.12L173.24 162.59C173.956 161.147 174.535 159.641 174.97 158.09H175.29L185.25 179ZM177 174.18L173.71 166.43L170.37 174.18H177Z"
              fill="#5C5C5C"
            />
            <path
              d="M229.91 181.48C227.18 181.71 223.18 182.15 219.63 180.1C217.404 181.343 214.878 181.948 212.33 181.85C206.62 181.85 199.33 179.91 199.33 173.44C199.33 169.53 202.33 167.54 204.8 166.72C203.761 165.197 203.191 163.403 203.16 161.56C203.16 156.99 207.54 154.92 212.16 154.92C215.05 154.92 218.23 155.78 219.5 157.56L218.18 162.9H217.83C217.83 159.55 216.5 156.48 213.13 156.48C212.559 156.465 211.991 156.569 211.462 156.785C210.933 157 210.454 157.323 210.056 157.732C209.658 158.142 209.349 158.629 209.148 159.164C208.947 159.699 208.86 160.27 208.89 160.84C208.89 163.73 211.11 166.02 215.19 169.58C216.76 170.95 219.19 173.11 220.9 174.52C221.563 172.497 221.474 170.303 220.65 168.34C220.49 167.857 220.186 167.435 219.778 167.131C219.37 166.827 218.879 166.655 218.37 166.64H217.81V166.27H226.51V166.64H226C224.86 166.64 224.67 167.42 224.68 168.64C224.841 171.338 224.293 174.03 223.09 176.45C225.81 178.82 227.93 180.54 229.86 181.11L229.91 181.48ZM205.24 172.69C205.49 177.69 209.47 180.28 213.73 180.28C215.249 180.301 216.734 179.827 217.96 178.93C215.46 177 212.34 174.35 210.96 173.15C209.273 171.752 207.695 170.228 206.24 168.59C205.468 169.811 205.117 171.251 205.24 172.69Z"
              fill="#5C5C5C"
            />
            <path
              d="M254.11 168.13C255.195 168.735 256.086 169.637 256.678 170.729C257.269 171.822 257.537 173.061 257.45 174.3C257.23 179.15 253.57 182 247.62 182C244.29 182 241.16 181.14 239.8 179.74C239.19 178.19 239.71 175.05 240.69 173.43H241C240.71 177.3 243.56 180.51 248 180.43C251.23 180.37 253.14 178.58 253.14 176.25C253.14 174.74 252.14 173.74 250.14 172.41L243.66 168.11C241.1 166.41 239.83 164.11 240.1 161.43C240.42 157.58 243.24 154.92 247.93 154.92C249.625 154.96 251.318 155.087 253 155.3H255.33L254.85 160.77H254.49C254.49 158.19 252.39 156.49 249.25 156.49C246.32 156.49 244.47 158.07 244.38 160.07C244.29 161.53 245.38 162.51 246.97 163.52L254.11 168.13ZM253.78 147.36L253.53 147.06L248.44 149.48L243 147.06L242.75 147.36L248.23 153.06H248.65L253.78 147.36Z"
              fill="#5C5C5C"
            />
            <path
              d="M271.36 159.16C277.36 159.16 279.87 161.86 280 165.32C280.23 171.23 274.24 174.38 269.35 171.1V170.78C269.35 170.78 272.99 171.2 274.12 167.03C274.276 166.375 274.35 165.703 274.34 165.03C274.376 164.436 274.284 163.84 274.071 163.284C273.859 162.728 273.53 162.223 273.107 161.804C272.684 161.385 272.177 161.061 271.618 160.853C271.06 160.645 270.464 160.559 269.87 160.6H268.17V179.11C268.17 179.64 268.381 180.149 268.756 180.524C269.131 180.899 269.64 181.11 270.17 181.11H270.61V181.48H260.37V181.11H260.81C261.332 181.11 261.833 180.906 262.207 180.542C262.581 180.178 262.797 179.682 262.81 179.16V161.49C262.81 160.96 262.599 160.451 262.224 160.076C261.849 159.701 261.341 159.49 260.81 159.49H260.37V159.12L271.36 159.16Z"
              fill="#5C5C5C"
            />
            <path
              d="M309 170.33C309 177.51 303.72 181.97 295.83 181.97C287.94 181.97 282.67 177.51 282.67 170.33C282.67 163.15 287.95 158.69 295.83 158.69C303.71 158.69 309 163.13 309 170.33ZM303.28 170.33C303.28 164.04 300.36 160.15 295.83 160.15C291.3 160.15 288.37 164.04 288.37 170.33C288.37 176.62 291.37 180.49 295.83 180.49C300.29 180.49 303.28 176.61 303.28 170.33Z"
              fill="#5C5C5C"
            />
            <path
              d="M328.58 181.48H311.09V181.11H311.53C312.05 181.11 312.55 180.908 312.923 180.546C313.297 180.183 313.514 179.69 313.53 179.17V161.51C313.53 160.98 313.319 160.471 312.944 160.096C312.569 159.721 312.06 159.51 311.53 159.51H311.1V159.14H321.4V159.51H321C320.731 159.501 320.464 159.545 320.213 159.642C319.962 159.738 319.733 159.884 319.54 160.07C319.347 160.257 319.193 160.481 319.089 160.728C318.984 160.975 318.93 161.241 318.93 161.51V180H323.41C326.56 180 328.7 177.95 329.67 174.66H330L328.58 181.48Z"
              fill="#5C5C5C"
            />
            <path
              d="M341.91 159.16V159.53H341.49C340.939 159.516 340.405 159.717 340 160.09C339.595 160.464 339.351 160.98 339.32 161.53V180.33C339.32 185.27 334.8 188.4 330.1 187.95V187.62C332.96 186.39 333.95 183.27 333.95 180.27V161.5C333.919 160.95 333.675 160.434 333.27 160.06C332.865 159.687 332.331 159.486 331.78 159.5H331.36V159.12L341.91 159.16Z"
              fill="#5C5C5C"
            />
            <path
              d="M364.66 179C364.894 179.591 365.295 180.102 365.813 180.471C366.331 180.84 366.944 181.052 367.58 181.08H367.86V181.45H356.93V181.08H357.22C357.468 181.094 357.716 181.04 357.936 180.924C358.157 180.809 358.342 180.636 358.472 180.424C358.602 180.212 358.673 179.968 358.676 179.719C358.679 179.47 358.615 179.225 358.49 179.01L357.05 175.61H349.17L347.68 179.06C347.571 179.276 347.521 179.516 347.534 179.757C347.547 179.998 347.623 180.231 347.755 180.434C347.886 180.636 348.069 180.801 348.284 180.91C348.499 181.02 348.739 181.072 348.98 181.06H349.27V181.43H341.84V181.06H342.13C342.738 181.033 343.327 180.837 343.83 180.495C344.334 180.152 344.732 179.676 344.98 179.12L352.65 162.59C353.374 161.15 353.956 159.643 354.39 158.09H354.7L364.66 179ZM356.42 174.15L353.13 166.4L349.8 174.15H356.42Z"
              fill="#5C5C5C"
            />
            <path
              d="M379.76 159.16C383.88 159.16 387.88 160.62 387.88 165.26C387.934 166.728 387.432 168.162 386.473 169.275C385.514 170.388 384.17 171.097 382.71 171.26C384.22 171.891 385.482 173.002 386.3 174.42C387.12 175.854 388.022 177.239 389 178.57C390.46 180.57 391.29 181.09 392.83 181.1V181.47H389.71C385.71 181.47 383.77 180.69 382 177.91C380.994 176.309 380.16 174.606 379.51 172.83C378.88 171.27 377.96 170.61 377.28 170.55V170.24H378.28C379.82 170.24 381.52 169.64 382.14 166.52C382.253 166.008 382.297 165.484 382.27 164.96C382.1 161.3 379.6 160.76 378.27 160.71C377.27 160.66 376.56 160.71 376.14 160.71V179.14C376.14 179.67 376.351 180.179 376.726 180.554C377.101 180.929 377.609 181.14 378.14 181.14H378.55V181.51H368.32V181.14H368.77C369.29 181.14 369.79 180.938 370.163 180.576C370.537 180.213 370.754 179.72 370.77 179.2V161.5C370.77 161.24 370.718 160.983 370.617 160.743C370.515 160.504 370.367 160.288 370.181 160.107C369.994 159.926 369.773 159.784 369.531 159.69C369.288 159.596 369.03 159.552 368.77 159.56H368.3V159.19L379.76 159.16Z"
              fill="#5C5C5C"
            />
            <path
              d="M392.52 181.48V181.11H393C393.273 181.121 393.545 181.077 393.801 180.982C394.057 180.888 394.291 180.743 394.491 180.557C394.691 180.371 394.852 180.148 394.965 179.899C395.078 179.651 395.141 179.383 395.15 179.11V161.51C395.141 161.237 395.078 160.969 394.965 160.721C394.852 160.472 394.691 160.249 394.491 160.063C394.291 159.877 394.057 159.732 393.801 159.638C393.545 159.543 393.273 159.499 393 159.51H392.56V159.14H403.11V159.51H402.68C402.127 159.488 401.588 159.687 401.182 160.062C400.775 160.436 400.533 160.957 400.51 161.51V179.17C400.533 179.723 400.775 180.244 401.182 180.618C401.588 180.993 402.127 181.192 402.68 181.17H403.12V181.54L392.52 181.48Z"
              fill="#5C5C5C"
            />
            <path
              d="M427.56 172.15L428 177.76C426.55 180.12 423.5 181.96 418.66 181.96C410.38 181.96 405.25 177.68 405.25 170.31C405.25 162.94 410.25 158.69 418.66 158.69C421.542 158.643 424.401 159.219 427.04 160.38V166.29H426.75C425.49 161.72 422.75 160.15 419.04 160.15C413.64 160.15 410.92 164.15 410.92 170.24C410.92 176.33 413.78 180.36 418.67 180.48C423.97 180.48 426.36 178.21 427.27 172.16L427.56 172.15ZM417.42 156.25C418.92 153.979 420.724 151.923 422.78 150.14C423.381 150.443 423.913 150.865 424.345 151.381C424.776 151.897 425.098 152.495 425.29 153.14C422.94 154.634 420.378 155.764 417.69 156.49L417.42 156.25Z"
              fill="#5C5C5C"
            />
            <path
              d="M228.16 52.91C224.62 52.91 222.39 54.91 222.28 57.33C222.17 59.14 223.53 60.33 225.41 61.61L226.97 62.61C227.34 62.61 227.71 62.66 228.1 62.66C232.04 62.58 234.38 60.43 234.45 57.66C234.455 57.6068 234.455 57.5532 234.45 57.5C234.07 54.75 231.66 52.99 228.17 52.99"
              fill="#A32324"
            />
            <path
              d="M160.74 106.52H267.26V0H160.74V106.52ZM221.85 21.33L228.61 24.33L234.9 21.33L235.21 21.67L228.84 28.67H228.33L221.54 21.67L221.85 21.33ZM198.78 48.56V48.11C200.401 48.2027 202.003 47.7241 203.308 46.7576C204.612 45.7911 205.537 44.3977 205.92 42.82C206.148 41.8948 206.246 40.9422 206.21 39.99C206.08 36.07 203.97 33.37 200.29 33.37H197.14V60.56C197.161 60.9283 197.257 61.2885 197.42 61.619C197.584 61.9496 197.813 62.2437 198.093 62.4837C198.373 62.7236 198.699 62.9046 199.051 63.0157C199.402 63.1267 199.773 63.1656 200.14 63.13H200.72V63.8H186.72V63.13H187.3C188.91 63.13 189.64 62.13 189.64 60.56V34.81C189.64 33.26 188.84 32.02 187.31 32.02H186.73V31.63L202.07 31.7C209.94 31.7 213.35 35.48 213.51 40.51C213.8 48.45 205.29 52.87 198.73 48.56H198.78ZM239.73 55.03C239.49 60.35 235.89 63.72 229.95 64.42L234.65 67.32C235.967 68.0868 237.041 69.2094 237.749 70.5591C238.456 71.9088 238.769 73.4307 238.65 74.95C238.38 80.95 233.97 84.49 226.78 84.49C222.78 84.49 218.97 83.49 217.32 81.72C216.58 79.79 217.21 75.98 218.39 73.95H218.79C218.43 78.68 221.87 82.66 227.26 82.57C231.17 82.49 233.48 80.23 233.48 77.34C233.48 75.48 232.3 74.22 229.88 72.58L221.36 67.24C218.27 65.14 216.73 62.3 217.06 58.95C217.161 57.0051 217.923 55.1529 219.22 53.7C221.198 51.8391 223.815 50.8082 226.53 50.82C227.1 50.8141 227.668 50.8813 228.22 51.02L222.71 47.35C219.54 45.25 217.97 42.42 218.31 39.07C218.7 34.3 222.19 30.96 227.99 30.96C229.47 30.96 232.16 31.34 234.26 31.34H237.15L236.55 38.1H236.1C236.1 35.4 233.51 32.9 229.61 32.9C225.99 32.9 223.7 34.9 223.61 37.42C223.5 39.23 224.89 40.42 226.82 41.7L235.59 47.4C238.33 49.18 239.92 51.59 239.72 55.03"
              fill="#A32324"
            />
          </g>
          <defs>
            <clipPath id="clip0_2_41">
              <rect width="428" height="187.99" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="rocisnik-top">
        <div>
          <div class="rokovnik-title">{{ getStranke }}</div>
          <div class="rokovnik-subtitle">
            {{ $t("reports.breakdown.subtitle") }}
          </div>
        </div>
      </div>
      <a @click="goBack()" class="entry-exit"
        ><img src="@/assets/img/entry_form_close.svg"
      /></a>
      <div class="breakdown-details-wrapper">
        <div>
          <span class="bolded">{{ $t("reports.breakdown.st1") }}</span
          ><span>{{ naziv_dokumenta }}</span
          ><br />
          <span class="bolded">{{ $t("reports.breakdown.st2") }}</span
          ><span>{{ getStranke }}</span
          ><br />
          <span class="bolded">{{ $t("reports.breakdown.st3") }}</span
          ><span>{{ getProtustranke }}</span
          ><br />
          <span class="bolded">{{ $t("reports.breakdown.st4") }}</span
          ><span>{{ predmet.ime_predmeta }}</span
          ><br />
        </div>
      </div>
      <div id="wrapp-roc-pdf">
        <div class="report-row report-main-header report-header1">
          <div class="column header1">{{ $t("reports.breakdown.hh") }}</div>
        </div>
        <div class="report-row report-main-header report-header2">
          <div class="column header1">{{ $t("reports.breakdown.hh1") }}</div>
          <div class="column header2">{{ $t("reports.breakdown.hh2") }}</div>
        </div>
        <div class="report-row report-main-header">
          <div class="column column1">
            {{ $t("reports.breakdown.h1") }}
          </div>
          <div class="column column2">
            {{ $t("reports.breakdown.h2") }}
          </div>
          <div class="column column3">
            {{ $t("reports.breakdown.h3") }}
          </div>
          <div class="column column4">
            {{ $t("reports.breakdown.h4") }}
          </div>
          <div class="column column5">
            {{ $t("reports.breakdown.h5") }}
          </div>
          <div class="column column6">
            {{ $t("reports.breakdown.h6") }}
          </div>
          <div class="column column7">
            {{ $t("reports.breakdown.h7") }}
          </div>
          <div class="column column8">
            {{ $t("reports.breakdown.h8") }}
          </div>
        </div>
        <div class="report-section">
          <div
            v-for="(bd, key) in breakdowns"
            :key="key"
            class="report-row report-rociste"
          >
            <div class="column column1">
              {{ predmet.broj_predmeta }}
            </div>
            <div class="column column2">
              {{ bd.satnica_service_types.type_name }}
            </div>
            <div class="column column3">
              {{ bd.description }}
            </div>
            <div class="column column4">
              {{ getDate(bd.date) }}
            </div>
            <div class="column column5">
              <div>
                <span>{{
                  bd.odvjetnik
                    ? bd.odvjetnik.ime + " " + bd.odvjetnik.prezime
                    : "Vanjski partner"
                }}</span>
                <div v-if="all_odvjetnici.length > 0 && bd.multi_person_uid.length > 0">Suradnici: {{ getOdvjetnikArray(bd.multi_person_uid) }}</div>
              </div>
            </div>
            <div class="column column6">
              {{
                bd.satnica
                  .toFixed(2)
                  .toString()
                  .replaceAll(".", ",")
                  .replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, "$1.")
              }}
              EUR
            </div>
            <div class="column column7">
              {{ `${bd.time_h}h ${bd.time_min}min` }}
            </div>
            <div class="column column8">
              {{
                getNaknada(bd)
                  .toFixed(2)
                  .toString()
                  .replaceAll(".", ",")
                  .replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, "$1.")
              }}
            </div>
          </div>
        </div>
        <div class="breakdown-report-bottom">
          <div class="punomocnik-wrapper">
            <span class="punomocnik-title">{{
              $t("reports.breakdown.lawyer")
            }}</span>
            <span>{{ punomocnik }}</span>
          </div>
          <div class="breakdown-dodatak">
            <div>
              {{ $t("reports.breakdown.total_time") }}&emsp;
              <span>{{ getUkSatiMin }}</span>
            </div>
            <div>
              {{ $t("reports.breakdown.total_money") }}&emsp;
              <span
                >{{
                  getValue
                    .toFixed(2)
                    .toString()
                    .replaceAll(".", ",")
                    .replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, "$1.")
                }}
                EUR</span
              >
            </div>
            <span class="u-pdv">{{ $t("reports.breakdown.no_vat") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import $ from "jquery";
import gsap from "gsap";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";

import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint";
import DataLoader from "@/components/generalComponents/DataLoader";

export default {
  components: {
    DataLoader,
  },
  data() {
    return {
      breakdowns: [],
      predmet: {
        ime_predmeta: "",
        broj_predmeta: "",
        prav_connect_protustranka: [],
        connect_fiz_protustranka: [],
        prav_connect_stranka: [],
        connect_fiz_stranka: [],
      },
      punomocnik: "",
      naziv_dokumenta: "",
      creating_report: false,
      all_odvjetnici: [],
    };
  },
  computed: {
    getUkSatiMin() {
      let uk_sati = this.breakdowns.reduce(function (prev, next) {
        return prev + Number(next.time_h);
      }, 0);
      let uk_min = this.breakdowns.reduce(function (prev, next) {
        return prev + Number(next.time_min);
      }, 0);
      if (uk_min >= 60) {
        const new_sati = parseInt(uk_min / 60);
        uk_sati += new_sati;
        uk_min = uk_min - new_sati * 60;
      }
      return `${uk_sati}h ${uk_min}min`;
    },
    getValue() {
      let _ = this;
      return this.breakdowns.reduce(function (prev, next) {
        return prev + Number(_.getNaknada(next));
      }, 0);
    },
    getStranke() {
      if (this.predmet) {
        let final_stranke1 = this.predmet.connect_fiz_stranka
          .map((st) => `${st.fizicka_osoba.ime} ${st.fizicka_osoba.prezime}`)
          .join(", ");
        let final_stranke2 = this.predmet.prav_connect_stranka
          .map((st) => `${st.pravna_osoba.ime}`)
          .join(", ");
        let final_stranke = [final_stranke1, final_stranke2]
          .filter((f) => f != "")
          .join(",");
        return final_stranke;
      }
      return "";
    },
    getProtustranke() {
      if (this.predmet) {
        let final_stranke1 = this.predmet.connect_fiz_protustranka
          .map((st) => `${st.fizicka_osoba.ime} ${st.fizicka_osoba.prezime}`)
          .join(", ");
        let final_stranke2 = this.predmet.prav_connect_protustranka
          .map((st) => `${st.pravna_osoba.ime}`)
          .join(", ");
        let final_stranke = [final_stranke1, final_stranke2]
          .filter((f) => f != "")
          .join(",");
        return final_stranke;
      }
      return "";
    },
  },
  methods: {
    async print() {
      this.creating_report = true;
      let temp_str = $("html").clone();
      $(temp_str).find(".print-wrapper,.entry-exit").remove();
      let html_to_print = $(temp_str)[0].outerHTML;
      await ms_calendar
        .printCalendar(html_to_print)
        .then(async (resp) => {
          var newBlob = new Blob([resp.data], {
            type: "application/pdf",
          });
          var data = window.URL.createObjectURL(newBlob);

          var link = document.createElement("a");
          link.href = data;
          console.log(link);
          link.download = `${this.$t(
            "reports.breakdown.file_name"
          )}${moment().format("l")}.pdf`;
          link.click();
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
          }, 100);
          this.creating_report = false;
        })
        .catch((_err) => {
          this.creating_report = false;
        });
      //html_to_print sadrzi html izvjestaj spreman za print
      //poslati html_to_print na back endpoint
    },
    getDate(date) {
      return moment(date).format("DD.MM.yyyy.");
    },
    getToday() {
      return moment().format("DD.MM.yyyy.");
    },
    getDayName(date) {
      return moment(date).format("dddd");
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    goBack() {
      this.$router.go(-1);
    },
    getNaknada(bd) {
      return bd.time_h * bd.satnica + (bd.time_min / 60) * bd.satnica;
    },
    getOdvjetnikArray(odvjetnik_uids) {

      return  this.all_odvjetnici
            .filter((p) => odvjetnik_uids.includes(p.id))
            .map((p) => p.naziv)
            .join(",")
    },
  },
  async created() {
    await predmet_hand.getAllOdvjetniciShort().then((resp) => {
      this.all_odvjetnici = resp.data;
      console.log(this.all_odvjetnici);
    });
  },
  mounted() {
    document.body.classList.add("new-entry");
    if (this.$store.state.breakdown_report_data == null) {
      this.$router.go(-1);
    }
    this.breakdowns = this.$store.state.breakdown_report_data.breakdown;
    this.breakdowns = this.breakdowns.sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    this.predmet = this.$store.state.breakdown_report_data.predmet_data;
    this.punomocnik = this.$store.state.breakdown_report_data.punomocnik;
    this.naziv_dokumenta =
      this.$store.state.breakdown_report_data.naziv_dokumenta;

    $(".entry-exit").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
  },
  destroyed() {
    document.body.classList.remove("new-entry");
    $(".entry-exit").off();
  },
};
</script>
